module.exports = __webpack_public_path__ + "img/point-blue-white.b9b7696c.png";